import styles from "./incomingBody.module.scss";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { getStringJson } from "../../../utils/getStringJson";

type IncomingBody = {
  isResponse?: boolean;
}

export const IncomingBody = ({isResponse}: IncomingBody) => {
  const { t } = useTranslation();

  const { selectedTestCaseIncoming, selectedTestCaseIncomingHistory } = useSelector((state: RootState) => state.testCaseIncomingSlice);

  const getSecondBody = (): string | undefined => {
    if (isResponse) {
      return selectedTestCaseIncoming.response;
    } else {
      return selectedTestCaseIncoming.request;
    }
  }

  const getMainBody = (): string | undefined => {
    if (isResponse) {
      return selectedTestCaseIncomingHistory.response;
    } else {
      return selectedTestCaseIncomingHistory.request;
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <span className={styles.response}>
          {isResponse ? t("common.response") : t("testCase.request")}
        </span>
        <span className={styles.expected}>
          {isResponse ? t("testCaseIncoming.expectedResponse") : t("testCaseIncoming.expectedRequest")}
        </span>
      </div>
      <div className={styles.bodyContainer}>
        <pre className={styles.body}>
          {getStringJson(getMainBody())}
        </pre>
        <pre className={styles.body}>
          {getStringJson(getSecondBody())}
        </pre>
      </div>
    </div>
  )
}

